import { Trend } from './trend';

export const MOCKTRENDS: Trend[] = [
  {
    title: 'Network',
    icon: 'fa fa-handshake-o',
    image: 'http://www.airpro.ie/wp-content/uploads/2014/02/shutterstock_123506017-Copy.jpg',
    description: 'blabla',
  }, {
    title: 'Technologies',
    icon: 'fa fa-laptop',
    image: 'https://citelighter-cards.s3.amazonaws.com/p17d98f5st15qd1tsv1m9c1sbu11uo0_64674.jpg',
    description: 'blabla',
  }, {
    title: 'Structures/ Values',
    icon: 'fa fa-anchor',
    image: 'http://workflow.arts.ac.uk/artefact/file/download.php?file=699293&view=89032',
    description: 'blabla',
  }, {
    title: 'Business strategy/ model',
    icon: 'fa fa-map',
    image: 'https://new.uschess.org/wp-content/uploads/2017/02/chess-pawn-king.jpg',
    description: 'blabla',
  }
];



// WEBPACK FOOTER //
// /Users/Myrberg/Documents/spring_repo1/spring-app/src/app/base/components/canvas/components/trends/trends/mock-trends.ts